import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import Nav    from "./components/Nav";
import Footer from "./components/Footer";
import Home      from "./pages/Home";
import Login     from "./pages/Login";
import Orders    from "./pages/Orders";
import Developer from "./pages/Developer";
import "./index.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Nav/>
        <Routes>
          <Route path="/"          element={<Home/>}/>
          <Route path="/login"     element={<Login/>}/>
          <Route path="/orders"    element={<Orders/>}/>
          <Route path="/developer" element={<Developer/>}/>
        </Routes>
        <Footer/>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: { background:"var(--bg3)", color:"var(--text)", border:"1px solid var(--border)", fontFamily:"var(--font-body)", fontSize:14 },
            success: { iconTheme: { primary:"var(--accent)", secondary:"#000" } },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
